<template>
  <div style="padding-left: 10px;padding-right: 10px;min-width: 200px;max-width: 300px;max-height: 250px;overflow: auto">
    <div class="col-xs-12">
      <span class="">Filter by universities, companies, ...</span>
    </div> <div class="col-xs-12" style="margin-top: 5px">
    <div class="row">
      <div class="col-xs-6">
        <a role="button" class="text-info"
           style="font-size: 12px;font-weight: normal;font-style: italic;" @click="feedFilter"> Select All</a>
      </div>
      <div class="col-xs-6 text-right">
        <a role="button" class="text-info"
           style="font-size: 12px;font-weight: normal;font-style: italic;" @click="clearFilter"> Clear All</a>
      </div>
    </div>
  </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div v-for="(affiliation, key) in sortedOrganisations" v-if="affiliation" :key="key" style="padding-top: 10px">
        <div class="checkbox checkbox-info checkbox-inline">
          <input v-bind:id="uniqId + 'checkbox-organisation-'+affiliation.id" type="checkbox"
                 v-on:change="affiliationSelected(affiliation)" v-bind:checked="checked(affiliation)"
                 :disabled="affiliation.nb === 0">
          <label :for="uniqId + 'checkbox-organisation-'+affiliation.id">
            <flag :squared="false" :iso="getIso(affiliation.country)" style="margin-right: 5px"/> {{affiliation.name}} ({{affiliation.nb}})
          </label>
        </div>
      </div>
    </div>
  </div>

</template>

<style>
  .pe-ul > li {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pe-ul > li > i{
    color: #62cb31;
    font-weight: bold;
  }

  .pe-ul > li > span{
    font-size: 14px;
    font-weight: normal;
  }

</style>
<script>

import IsoCountries from 'i18n-iso-countries'
import EnCountries from '../../iconFlag/en'

IsoCountries.registerLocale(EnCountries)

export default {
  components: {},
  props: ['affiliations', 'affiliationsSelected'],
  name: 'OrganisationBox',
  data () {
    return {
      uniqId: ''
    }
  },
  computed: {
    sortedOrganisations: function () {
      let undefinedItems = [], sortedItems = []
      if (this.affiliations.length !== 0) {
        this.affiliations.forEach((item, key) => {
          if (item.name === '' || typeof item.name === 'undefined' || item.name.toLowerCase() === 'undefined' ||
              item.name.toLowerCase() === 'unknown' || item.name.toLowerCase() === 'incomplete') {
            undefinedItems.push(item)
          } else {
            sortedItems.push(item)
          }
        })
        undefinedItems.sort(function (a, b) { return a.name > b.name })
        return sortedItems.concat(undefinedItems)
      } else {
        return []
      }
    }
  },
  methods: {
    checked: function (affiliation) {
      if (this.affiliationsSelected.length !== 0) {
        let tmpAffiliationSelected = this.affiliationsSelected.find((affiliationSelected) => {
          return affiliationSelected.id === affiliation.id
        })
        if (typeof tmpAffiliationSelected !== 'undefined') {
          return true
        }
      }
      return false
    },
    affiliationSelected: function (affiliation) {
      let index = this.affiliationsSelected.map((e) => {
        return e.id
      }).indexOf(affiliation.id)

      if (index === -1) {
        this.affiliationsSelected.push(affiliation)
      } else {
        this.affiliationsSelected.splice(index, 1)
      }
    },
    clearFilter: function (event) {
      this.affiliationsSelected.splice(0, this.affiliationsSelected.length)
      event.preventDefault()
    },
    feedFilter: function (event) {
      this.clearFilter(event)

      this.affiliations.forEach((affiliation) => {
        this.affiliationsSelected.push(affiliation)
      })
      event.preventDefault()
    },
    getIso: (country) => {
      if (typeof country !== 'undefined') {
        let iso = IsoCountries.getAlpha2Code(country, 'en')
        if (typeof iso === 'undefined') {
          iso = IsoCountries.toAlpha2(country.code)
        }
        return iso
      }
    }
  },
  beforeMount () {
    this.uniqId = Math.random().toString()
  },
  mounted () {
  }

}
</script>



// WEBPACK FOOTER //
// src/components/filter/OrganisationBox.vue